<template>

  <!-- Header Box with important information -->
  <v-container id="summary-box"
       :class="{ 'sticky-box': !isEdge() }"
       class="fixed-box summary-box round-corners pa-0">
    <div class="padding-box1">
      <h1>Zusammenfassung</h1>

      <v-divider class="h1h2divider" />

      <h2>Basisdaten</h2>

      <summary-box-line v-if="firstName.length > 0 || lastName.length > 0">
        {{ firstName }} {{ lastName }}
      </summary-box-line>

      <summary-box-line v-if="civilServant">im öffentlichen Dienst tätig</summary-box-line>

      <summary-box-line>
        {{ family === 'MPH' ? 'Familie' : family === 'EPH' ? 'Single/Alleinerziehend mit Kind' : 'Familienstand n.a.' }}
      </summary-box-line>

      <summary-box-line>
        Laufzeit: {{ getContractLength(statePath) }} Jahr{{ getContractLength(statePath) == '3' ? 'e' : '' }}
      </summary-box-line>
    </div>


    <!-- Details Box with less important information -->
    <div v-if="categories.length > 0"
         class="scrollable-box padding-box2 bg-dimmed">
      <h2>Versicherungs&shy;schutz</h2>

      <template v-if="!sus">
        <summary-box-line>
          <div v-if="productLine !== ''">{{ productLineText(productLine, activeTarif) }}</div>
          <span>{{ getProductText(statePath) + ((trafficType === 'Fahrzeug' && showkfz ) ? ' (' + (showkfz + 1) + ' Kfz)' : '') }}</span>
        </summary-box-line>
        <summary-box-line v-if="getSb(statePath) !== -1">
          Selbstbeteiligung {{ getSb(statePath) === 0 && tarifIsCharta(statePath) ? 50 : getSb(statePath) }}&nbsp;€
        </summary-box-line>

      </template>
      <template v-else>
        <summary-box-line>
          Schnell &amp; Sicher
        </summary-box-line>
        <summary-box-line>
          <span>Selbstbeteiligung&nbsp;{{ getSb(statePath) }}&nbsp;€</span>
        </summary-box-line>
      </template>
      <template v-if="currentPraemien.main">
        <summary-box-line>
          <span slot="left">{{ praemienName(zahlweise) }}</span>
          <span slot="right">{{ $helpers.toGermanFloatString(currentPraemien.main) }}&nbsp;€</span>
        </summary-box-line>
        <summary-box-line v-if="showAdditionalPayment">
          <span slot="left">{{ praemienName(smallestPraemien.zahlweise) }}</span>
          <span slot="right">{{ $helpers.toGermanFloatString(smallestPraemien.praemien.main) }}&nbsp;€</span>
        </summary-box-line>
      </template>

      <div v-if="ssrselected||cyberselected|| vermselected && vermwohnungen[0].bruttojahresmiete >= 100 || zwselected">

        <v-divider />
        <div class="summary-box-line">
          <h2>Zusatzbausteine</h2>
        </div>

        <template v-if="cyberselected">
          <div class="summary-box-line">
            <h3>Cyber-Rechtsschutz</h3>
          </div>
          <summary-box-line>
            <span>Selbstbeteiligung&nbsp;{{ cybersb.slice(2) }}&nbsp;€</span>
          </summary-box-line>
          <summary-box-line>
            <span slot="left">{{ praemienName(zahlweise) }}</span>
            <span slot="right">{{ $helpers.toGermanFloatString(currentPraemien.cyber) }}&nbsp;€</span>
          </summary-box-line>
          <summary-box-line v-if="showAdditionalPayment">
            <span slot="left">{{ praemienName(smallestPraemien.zahlweise) }}</span>
            <span slot="right">{{ $helpers.toGermanFloatString(smallestPraemien.praemien.cyber) }}&nbsp;€</span>
          </summary-box-line>
          <v-divider v-if="ssrselected || zwselected ||
          (vermselected && vermvalid && getWohnungsPrice(zahlweise) > 0)" />
        </template>


        <template v-if="ssrselected">
          <div class="summary-box-line">
            <h3>Spezial-Straf-Rechtsschutz</h3>
          </div>
          <summary-box-line>
            <span>Selbstbeteiligung&nbsp;{{ getSsrSb(statePath) === 0 && tarifIsCharta(statePath) ? 50 : getSsrSb(statePath) }}&nbsp;€</span>
          </summary-box-line>
          <summary-box-line>
            <span slot="left">{{ praemienName(zahlweise) }}</span>
            <span slot="right">{{ $helpers.toGermanFloatString(currentPraemien.ssr) }}&nbsp;€</span>
          </summary-box-line>
          <summary-box-line v-if="showAdditionalPayment">
            <span slot="left">{{ praemienName(smallestPraemien.zahlweise) }}</span>
            <span slot="right">{{ $helpers.toGermanFloatString(smallestPraemien.praemien.ssr) }}&nbsp;€</span>
          </summary-box-line>
          <v-divider v-if="zwselected ||
          (vermselected && vermvalid && getWohnungsPrice(zahlweise) > 0)" />
        </template>


        <template v-if="zwselected">
          <div class="summary-box-line">
            <h3>zusätzliche Zweit-/Ferienwohnung</h3>
          </div>
          <summary-box-line>
            <span>Selbstbeteiligung&nbsp;{{ getSb(statePath) === 0 && tarifIsCharta(statePath) ? 50 : getSb(statePath) }}&nbsp;€</span>
          </summary-box-line>
          <summary-box-line>
            <span slot="left">{{ praemienName(zahlweise) }}</span>
            <span slot="right">{{ $helpers.toGermanFloatString(currentPraemien.zweitwohnung) }}&nbsp;€</span>
          </summary-box-line>
          <summary-box-line v-if="showAdditionalPayment">
            <span slot="left">{{ praemienName(smallestPraemien.zahlweise) }}</span>
            <span slot="right">{{ $helpers.toGermanFloatString(smallestPraemien.praemien.zweitwohnung) }}&nbsp;€</span>
          </summary-box-line>
          <v-divider v-if="vermselected && vermvalid && getWohnungsPrice(zahlweise) > 0" />
        </template>


        <template v-if="vermselected">
          <div class="summary-box-line">
            <h3>vermietete Wohneinheit{{ vermwohnungen.length > 1 ? 'en' : '' }} ({{ vermwohnungen.length }})</h3>
          </div>
          <div v-if="vermvalid && getWohnungsPrice(zahlweise) > 0">
            <summary-box-line>
              <span>Selbstbeteiligung&nbsp;{{ sbTextVermietet }}&nbsp;€</span>
            </summary-box-line>
            <summary-box-line>
              <span slot="left">{{ praemienName(zahlweise) }}</span>
              <span slot="right">{{ $helpers.toGermanFloatString(getWohnungsPrice(zahlweise)) }}&nbsp;€</span>
            </summary-box-line>
            <summary-box-line v-if="showAdditionalPayment">
              <span slot="left">{{ praemienName(smallestPraemien.zahlweise) }}</span>
              <span slot="right">{{ $helpers.toGermanFloatString(getWohnungsPrice(smallestPraemien.zahlweise)) }}&nbsp;€</span>
            </summary-box-line>
          </div>
          <div v-if="!(vermvalid && getWohnungsPrice(zahlweise) > 0)">
            <span class="error--text">Bitte Angaben vervollständigen</span>
          </div>
        </template>
      </div>
      <v-spacer style="height: 8px" />
    </div>


    <!-- Footer Box with important information -->
    <div v-if="currentPraemien.main > 0 || activeStepNumber === 2"
         class="padding-box3">
      <div v-if="currentPraemien.main > 0">
        <summary-box-line>
          <h3 slot="left">{{ praemienName(zahlweise) }}</h3>
          <h3 slot="right"
              class="text-bold"
              style="padding-right: 16px">{{ $helpers.toGermanFloatString(currentPraemien.total) }}&nbsp;€ </h3>
        </summary-box-line>
        <summary-box-line v-if="showAdditionalPayment">
          <h3 slot="left">{{ praemienName(smallestPraemien.zahlweise) }}</h3>
          <h3 slot="right"
              class="text-bold"
              style="padding-right: 16px">{{ $helpers.toGermanFloatString(smallestPraemien.praemien.total) }}&nbsp;€ </h3>
        </summary-box-line>
      </div>

      <v-row v-if="isVorschlagAllowed"
             class="kurzangebot-btn fill-parent"
             align="center"
             justify="center"
             no-gutters>
        <v-btn color="primary"
               class="standard-button ma-2"
               @click="$emit('kurzangebot')">Vorschlag erstellen
        </v-btn>
        <v-btn v-if="angebotfremdPossible"
               color="primary"
               class="standard-button ma-2"
               @click="$emit('kurzangebotfremd')">Vorschlag für {{ selectedIdentityVmnr }}
        </v-btn>
      </v-row>

    </div>
    <!--div style="height: 68px; background-color: #fff;"/-->
  </v-container>
</template>
<script>
import {mapGetters} from "vuex";
import KeyTranslator from "@/components/helper/keyTranslatorMixin";
import ValidationMixin from "@/components/helper/ValidationMixin";
import BrowserDetectionMixin from "@/components/helper/BrowserDetectionMixin";
import SummaryBoxLine from "@/components/privatkundenrechner/SummaryBoxLine";
import {mapTwoWay} from "@/store/twowayBindingMixin";
import twowayBinding from "@/store/twowayBindingMixin";

export default {
  name: "SummaryBox",
  components: { SummaryBoxLine },
  mixins: [twowayBinding, ValidationMixin, KeyTranslator, BrowserDetectionMixin],
  computed: {
    ...mapGetters([
      "getContractLength",
      "productLineText",
      "getProductText",
      "getSb",
      "getSsrSb",
      "tarifIsCharta",
      "activeTarif",
      "premiumMinimum"
    ]),
    smallestPraemien() {
      let zahlweisen = ["12", "4", "2"];
      let customPraemien = this.$store.getters.customPraemien(this.statePath);
      for (let i = 0; i < 3; i++) {
        let praemien = customPraemien(zahlweisen[i]);
        if (praemien.total >= this.premiumMinimum || i === 2)
          return { praemien, zahlweise: zahlweisen[i] };
      }
      return null;
    },
    currentPraemien() {
      //console.log("currentPraemien",this.$store.getters.currentPraemien(this.statePath));
      return this.$store.getters.currentPraemien(this.statePath);
    },
    activeStepNumber() {
      return this.statePath === "editContract" ? this.$store.state.s.aenderung.activeStepNumber : this.$store.state.s.privat.activeStepNumber;
    },
    isVorschlagAllowed() {
      return this.activeStepNumber === 2 && !!this.sb && !(this.vermselected && !this.vermvalid);
    },
    showAdditionalPayment() {
      return this.rechnungszahler === 'N' && this.zahlweise !== this.smallestPraemien.zahlweise;
    },
    sbTextVermietet() {
      return this.vermwohnungen[0].sb === "SB300" ? "300" : "500";
    },
    selectedIdentityVmnr() {
      return this.$store.state[this.statePath].selectedIdentity.vmnr;
    },
    angebotfremdPossible() {
      const mystate = this.$store.state[this.statePath];
      if( (mystate.selectedIdentity.username ?? "") == "") {return false;}
      if( !this.$store.state.user.authorization.roles.includes('fremdangebot')) {return false;}
      if( mystate.selectedIdentity.vmnr == this.$store.state.user.vmnr) {return false;}
      if( mystate.selectedTarif !== mystate.selectedIdentity.tarifname) {return false;}
      return true;
    },
    ...mapTwoWay(
      [
        "ssrselected",
        "ssrsb",
        "cyberselected",
        "cybersb",
        "zwselected",
        "sb",
        "zahlweise",
        "contractlength",
        "civilServant",
        "family",
        "productLine",
        "lastName",
        "firstName",
        "sus",
        "vermselected",
        "vermvalid",
        "vermwohnungen",
        "rechnungszahler",
        "categories",
        "trafficType",
        "showkfz"
      ],
      {
        firstName: "vn.firstname",
        lastName: "vn.lastname"
      }
    )
  },
  methods: {
    getWohnungsPrice: function (payment) {
      if (!this.vermvalid) {
        return 0.0;
      }
      if (!this.vermselected) {
        return 0.0;
      }
      if (payment === this.smallestPraemien.zahlweise) {
        return this.smallestPraemien.praemien.vermieter.reduce((vermieterTotal, wohnung) => vermieterTotal + wohnung.praemie, 0.0);
      } else {
        return this.currentPraemien.vermieter.reduce((vermieterTotal, wohnung) => vermieterTotal + wohnung.praemie, 0.0);
      }
    }
  }
};
</script>
<style>

.padding-box1 {
  padding: 16px 16px 8px 16px;
}

.padding-box2 {
  padding: 8px 16px 0 16px;
}

.padding-box3 {
  padding: 16px 16px 8px 16px;
}

.kurzangebot-btn {
  margin-top: 0;
}

.sticky-box {
  position: sticky;
  position: -webkit-sticky;

}

.fixed-box {
  top: 180px !important;
  width: 100%;
  z-index: 6;
  margin: 0;
}

@media screen and (max-width: 1100px) , screen and (max-height: 800px) {
  .fixed-box {
    top: 92px !important;
  }
}

.scrollable-box {
  max-height: calc(100vh - 136px - 48px - 233px - 136px) !important;
  overflow-y: scroll;
}

.summary-box {
  max-height: calc(100vh - 136px - 48px) !important;
  background-color: #ebebeb !important;

}

.summary-box h1 {
  font-size: 24px !important;
  font-weight: 400;
  line-height: 32px !important;
  color: #0085CF !important;
}

.summary-box h2 {
  line-height: 24px !important;
  font-size: 20px !important;
  font-weight: 400;
  color: #0085CF !important;
}

.summary-box h3 {
  line-height: 32px !important;
  font-size: 16px !important;
  font-weight: 400;
  color: #0085CF !important;
}

.summary-box .summary-box-line {
  line-height: 24px !important;
  font-weight: 400;
  font-size: 16px;
}

.summary-box .v-divider {
  margin-top: 8px;
  margin-bottom: 0;
}

.text-bold {
  font-weight: 700 !important;
}

</style>

